import App from '@/app/App'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import 'scss/styles.scss'

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  // <React.StrictMode>
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  // </React.StrictMode>,
)